export default __webpack_public_path__ + "static/dethatch-4379fd85eeb0c734bc4787021b3dcebe.webp";